var initialState = {
    initialized: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'LOAD_MINE':
            return {
                ...state, ...action.data,
                initialized: true
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/profile.js